import parse from 'html-react-parser'
import styles from "./IntroMessage.module.css";

interface IntroMessageProps {
  introMessage: string;
  linkUrl?: string;
  linkText?: string;
  ariaLabel?: string;
}

const IntroMessage = ({ introMessage }: IntroMessageProps) => {
  return (
    <section className={styles.introMessage}>
      <p>{parse(introMessage)}</p>
    </section>
  );
};

export default IntroMessage;